import { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
	HideShowImg,
	PasswordInputContainter,
	SettingsContainer, SettingsHeader, SettingsOptionsContainer, SettingsTextInput, Understanding
} from '../components/SettingsStyles'
import { useNavigate, useParams } from 'react-router-dom';
import { BlueButton } from '../../Global/GobalStyledComponents';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { selectModalOpen, setModalContent, setModalOpen } from '../../Modal/modalSlice';
import {
	postPasswordReset, selectPasswordResetStatus, selectUserError, selectUserErrorCode,
	setPageFirstLoad, selectPageFirstLoad
} from '../SettingsState/userSlice';
import { DataState, ModalState } from '../../../interfaces/enums';
import GridLoading from '../../GridPages/components/GridLoading';
import GridFailed from '../../GridPages/components/GridFailed';
import { passwordValidation } from '../../Global/GobalFunctions';
import { handleGA4PageHit } from '../../Global/GA4Functions';
import ShowPassImg from '../../../img/Icons/Gray Icons/showPass.png'
import HidePassImg from '../../../img/Icons/Gray Icons/hidePass.png'

const PasswordResetTokenPage = () => {
	const params = useParams();
	const nav = useNavigate();
	const modalOpen = useAppSelector(selectModalOpen);
	const dispatch = useAppDispatch();
	const status = useAppSelector(selectPasswordResetStatus);
	const errorMessage = useAppSelector(selectUserError);
	const errorCode = useAppSelector(selectUserErrorCode);
	const firstLoad = useAppSelector(selectPageFirstLoad)
	let passwordResetToken = '';
	let email = ''
	const [password, setPassword] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')
	const [isValid, setIsValid] = useState(true);
	const [passwordValidtionMessage, setPasswordValidtionMessage] = useState('');
	const [showNewPass, setShowNewPass] = useState(false);
	const [showConfirmPass, setShowConfirmPass] = useState(false);

	if (params.token !== undefined && params.email !== undefined) {
		passwordResetToken = params.token;
		email = params.email;
	} else {
		nav('pagenotfound', { replace: true })
	}

	useEffect(() => {
		document.title = "Password Reset | TitanTV";
		document.querySelector('meta[name="description"]')?.setAttribute('content', "Resets a forgotten password to allow the member to log in to their account.");
		document.querySelector('meta[name="robots"]')?.setAttribute('content', "noindex");
		handleGA4PageHit({ page: '/passwordreset', title: 'Password Reset' })
		if (modalOpen === true) {
			dispatch(setModalOpen());
		}
		if (firstLoad === true) {
			setPageFirstLoad(false);
		}
	}, [])

	const handleUpdatePassword = () => {
		setIsValid(passwordValidation(password));
		if (isValid && password === confirmPassword && password !== '') {
			setIsValid(true);
			dispatch(postPasswordReset({ email, passwordResetToken, password }));
		} else {
			setIsValid(false);
			if (!isValid || password === '') {
				setPasswordValidtionMessage('Password must contain an Uppercase letter, a lowercase letter, a number and must be 8 characters')
			} else {
				setPasswordValidtionMessage('New Password and Confirm Password must match')
			}
		}
	}

	const login = () => {
		dispatch(setModalContent(ModalState.LOGIN));
		dispatch(setModalOpen())

		nav('/', { replace: true })
	}

	return (
		<SettingsContainer>
			<SettingsOptionsContainer>
				<SettingsHeader>
					Password Reset
				</SettingsHeader>
				<PasswordInputContainter>
					<SettingsTextInput name='newPassword' value={password} onChange={(e) => setPassword(e.target.value)} type={showNewPass ? 'text' : 'password'} placeholder='New Password' />
					<HideShowImg src={showNewPass ? HidePassImg : ShowPassImg} onClick={() => setShowNewPass(!showNewPass)} />
				</PasswordInputContainter>
				<PasswordInputContainter>
					<SettingsTextInput name='confirmNewPassword' value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} type={showConfirmPass ? 'text' : 'password'} placeholder='Confirm New Password' />
					<HideShowImg src={showConfirmPass ? HidePassImg : ShowPassImg} onClick={() => setShowConfirmPass(!showConfirmPass)} />
				</PasswordInputContainter>
				<PasswordUpdateStatus>
					{isValid ? '' : passwordValidtionMessage}
					{status === DataState.IDLE ? ''
						: status === DataState.LOADING ? <GridLoading />
							: status === DataState.FAILED ? <GridFailed errorCode={errorCode} errorMessage={errorMessage} />
								: 'Password Updated'
					}
				</PasswordUpdateStatus>
				<BlueButton onClick={() => handleUpdatePassword()}>Update Password</BlueButton>
				<BlueButton onClick={() => login()}>Login</BlueButton>
			</SettingsOptionsContainer>
			<Understanding>
				<span>
					<b>About This Page:</b>
					<p>This page is for reseting the password on your account</p>
					<p>Enter in a new password to change the password on your account</p>
				</span>
			</Understanding>
		</SettingsContainer>
	)
}

export default PasswordResetTokenPage

const PasswordUpdateStatus = styled.div`
	font-size: 16px;
	color: red;
`